import pic1 from "../assets/Bat-Cat.png";
import pic2 from "../assets/Blue-Cat.png";
import pic3 from "../assets/Lion-Cat.png";
import pic4 from "../assets/Mystical-Cat.png";
import pic5 from "../assets/Pig-Cat.png";
import pic6 from "../assets/White-Cat.png";

export const images = [pic1, pic2, pic3, pic4, pic5, pic6];
